import { render } from "./orderpg.vue?vue&type=template&id=4991fcf2"
import script from "./orderpg.vue?vue&type=script&lang=js"
export * from "./orderpg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__